import _ from 'lodash'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import FileSaver from 'file-saver'
import { t } from '@lingui/macro'

import { useRequestHandler } from '@/hooks/useRequestHandler'
import {
  downloadConsent as downloadConsentAction,
  selectDownloadedConsentByPatientId,
  selectPatientDownloadConsentRequestTracker,
} from '@/redux/reducers/patient.reducer'
import { useAppSelector } from '@/redux/rootReducer'

export function useDownloadConsent(patientId: string) {
  const { enqueueSnackbar } = useSnackbar()

  const downloadedConsentDataUrl = useAppSelector((state) => (patientId ? selectDownloadedConsentByPatientId(state, patientId) : undefined))

  const [enableDownload, setEnableDownload] = useState<boolean>(false)

  const patientDownloadConsentRequestHandler = useRequestHandler({
    onSuccess: () => {
      setEnableDownload(true)
    },
    onError: () => enqueueSnackbar(t`An error has occured while downloading the consent. Please try again!`, { variant: 'error' }),
    requestTrackerSelector: selectPatientDownloadConsentRequestTracker,
  })

  useEffect(() => {
    if (downloadedConsentDataUrl && enableDownload) {
      setEnableDownload(false)
      const filename = _.split(
        _.find(_.split(downloadedConsentDataUrl, ';'), (str) => _.startsWith(str, 'filename')),
        '='
      )[1]
      // Extract file type from the data URL
      const fileType = _.split(
        _.find(_.split(downloadedConsentDataUrl, ';'), (str) => _.startsWith(str, 'data:')),
        ':'
      )[1]
        .split('/')[1]
        .split(';')[0]

      FileSaver.saveAs(downloadedConsentDataUrl, filename)

      // Send message to React Native app
      try {
        const messageData = JSON.stringify({ fileName: filename, fileType, src: downloadedConsentDataUrl })
        if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(messageData)
      } catch (err) {
        console.log('Error posting message:', err)
      }
    }
  }, [downloadedConsentDataUrl, enableDownload])

  const downloadConsent = () => {
    patientDownloadConsentRequestHandler.dispatch(downloadConsentAction(patientId))
  }

  return { downloadConsent, isDownloadingConsent: patientDownloadConsentRequestHandler.requestTracker.loading }
}
